module.exports = __webpack_public_path__ + "static/13-sunna-10c45075a671e267b5a8099c9688f4ab.jpg";